<template>
  <material-dialog
    cancelText="Anuluj"
    confirmText="Zmień hasło"
    title="Zmiana hasła"
    :show="show"
    :width="450"
    :close-on-confirm="false"
    @confirm="confirm"
    v-on="$listeners"
  >
    <div slot="body">
      <password-input :model="$schema.password" />

      <password-input :model="$schema.newPassword" />

      <password-input :model="$schema.confirmPassword" />

      <span>
        <small>
          Hasło musi składać się z minimum 14 znaków (w tym cyfry, znaku specjalnego, małej oraz wielkiej litery)
        </small>
      </span>
    </div>
  </material-dialog>
</template>

<script>
import { schemaMixin } from '@witkac/vuetify-components';

import PasswordInput from '@/components/forms/PasswordInput';
import MaterialDialog from '@/components/material/Dialog';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/changePassword.schema';

export default {
  mixins: [notificationsMixin, schemaMixin],
  components: { MaterialDialog, PasswordInput },
  props: {
    // czy pokazać modala
    show: { type: Boolean }
  },
  data() {
    return { model: {} };
  },
  schema,
  methods: {
    confirm() {
      if (this.$schema.$validateAll().length) {
        this.notifyError('Należy poprawić błędy formularza.');
        return;
      }
      this.$emit('change-password', this.$schema.$getData());
    }
  },
  watch: {
    show() {
      this.$schema.$setData({ password: '', newPassword: '', confirmPassword: '' });
      this.$schema.$reset();
    }
  }
};
</script>
